import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/generate/record/page', data, {
    trim: true
  })
}

// 查询
export function fetchById (id) {
  return request.get(`/generate/record/${id}`)
}

// 导出招标书
export function exportBook (id) {
  return request.get(`/generate/record/exportBook/${id}`, {
    download: true
  })
}
// 部署
export function deployById (id) {
  return request.get(`/generate/record/deploy/${id}`)
}

// 停止部署
export function killDeployById (id) {
  return request.get(`/generate/record/deploy/kill/${id}`)
}

// 获取任务
export function findDeployTaskById (id) {
  return request.get(`/generate/record/deploy/task/${id}`)
}

// 导出代码文档
export function exportCodeBook (id) {
  return request.get(`/generate/record/exportCodeBook/${id}`, {
    download: true
  })
}

// 导出精简版代码文档
export function simpExportCodeBook (id) {
  return request.get(`/generate/record/exportSimpCodeBook/${id}`, {
    download: true
  })
}

// 导出招标书
export function regen (id) {
  return request.get(`/generate/record/regen/${id}`, {
    download: true
  })
}

// 系统介绍文档
export function exportSystemBook (id) {
  return request.get(`/generate/record/exportSystemBook/${id}`, {
    download: true
  })
}

// 删除
export function deleteById (id) {
  return request.get(`/generate/record/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/generate/record/delete/batch', {
    params: {
      ids
    }
  })
}

// 编辑
export function updateById (data) {
  return request.post('/generate/record/updateById', data)
}
